import Joi from 'joi';

export const createSourceRegistryFormSchema = Joi.object({
  sourceName: Joi.string().required(),
  identifier: Joi.string().required(),
  configJson: Joi.object({
    requestSpecJson: Joi.string().allow(null, '').optional(),
    responseSpecJson: Joi.string().allow(null, '')
  }).allow({}, null).optional(),
  eventName: Joi.string().allow(null, '').optional(),
  eventVersion: Joi.number().allow(null).optional(),
  patterns: Joi.array().items({
    eventName: Joi.string().optional(),
    eventVersion: Joi.number(),
    occurrences: Joi.string(),
    patternDefinition: Joi.object({
      fieldConditionCombiners: Joi.array().items({
        combiner: Joi.string(),
        fieldConditionRefs: Joi.array().items(Joi.string()),
        n: Joi.number()
      }),
      fieldConditions: Joi.object().pattern(/.*/, Joi.object({
        contentRef: Joi.object({
          contentType: Joi.string(),
          conversionPattern: Joi.string().optional(),
          path: Joi.array().items(Joi.string()),
          required: Joi.boolean().optional()
        }),
        operator: Joi.string(),
        value: Joi.string(),
      }))
    }),
    patternName: Joi.string(),
    timeToLive: Joi.string().optional(),
    uniqueId: Joi.string().optional()
  }),
  replyTimeout: Joi.string().allow(null, '').optional(),
  replyTopicName: Joi.string().allow(null, '').optional()
});

export const createSourceRegistryResponseSchema = Joi.array().items({
  id: Joi.string(),
  sourceName: Joi.string().required(),
  identifier: Joi.string().required(),
  status: Joi.string(),
  version: Joi.number().allow(null).optional(),
  createdBy: Joi.string().optional(),
  updatedBy: Joi.string().optional(),
  createdTimestamp: Joi.string(),
  updatedTimestamp: Joi.string(),
  configJson: Joi.object({
    requestSpecJson: Joi.string(),
    responseSpecJson: Joi.string(),
  }).allow(null).optional(),
  eventName: Joi.string().optional().allow('', null),
  eventVersion: Joi.number().optional().allow(null),
  patterns: Joi.array().items({
    eventName: Joi.string(),
    eventVersion: Joi.number(),
    occurrences: Joi.string(),
    patternDefinition: Joi.object({
      fieldConditionCombiners: Joi.array().items({
        combiner: Joi.string(),
        fieldConditionRefs: Joi.array().items(Joi.string()),
        n: Joi.number()
      }),
      fieldConditions: Joi.object().pattern(/.*/, Joi.object({
        contentRef: Joi.object({
          contentType: Joi.string(),
          conversionPattern: Joi.string().optional(),
          path: Joi.array().items(Joi.string()),
          required: Joi.boolean().optional()
        }),
        operator: Joi.string(),
        value: Joi.string(),
      }))
    }),
    patternName: Joi.string(),
    timeToLive: Joi.string().optional(),
    uniqueId: Joi.string().optional()
  }),
  replyTimeout: Joi.string().optional().allow('', null),
  replyTopicName: Joi.string().optional().allow('', null)
});

export const sourceRegistryNameSchema = Joi.string();

export const registryListSchema = Joi.object({
  pageNo: Joi.number(),
  item: Joi.number()
});

export const sourceRegistryListResponseSchema = Joi.object({
  item: Joi.number(),
  currentPageNumber: Joi.number(),
  numberOfRecordsPerPage: Joi.number(),
  totalRecords: Joi.number(),
  numberOfPages: Joi.number(),
  sources: Joi.array().items({
    id: Joi.string(),
    name: Joi.string(),
    identifier: Joi.string(),
    status: Joi.string(),
    version: Joi.number(),
    createdBy: Joi.string().optional(),
    updatedBy: Joi.string().optional(),
    createdOn: Joi.string().optional(),
    updatedOn: Joi.string().optional()
  }),
});

export const sourceListRegistrySchema = Joi.object({
  currentPageNumber: Joi.number(),
  numberOfRecordsPerPage: Joi.number(),
  totalRecords: Joi.number(),
  numberOfPages: Joi.number(),
  sources: Joi.array().items({
    sourceName: Joi.string(),
    identifier: Joi.string().allow('', null).optional(),
    eventName: Joi.string().allow('', null).optional(),
    eventVersion: Joi.number().allow(null).optional(),
    status: Joi.string(),
    version: Joi.number().allow('', null).optional(),
    updatedBy: Joi.string(),
    updatedTimestamp: Joi.string(),
  })
}).options({ stripUnknown: true });

export const getFSMListResponseSchema = Joi.object({
  item: Joi.number(),
  currentPageNumber: Joi.number(),
  numberOfRecordsPerPage: Joi.number(),
  totalRecords: Joi.number(),
  numberOfPages: Joi.number(),
  businessObjects: Joi.array().items({
    businessObjectDescription: Joi.string().optional().allow(''),
    businessObjectName: Joi.string(),
    businessObjectType: Joi.string(),
    businessObjectUUId: Joi.string(),
    businessSchemaName: Joi.string().optional(),
    businessSchemaVersion: Joi.number().optional(),
    createdBy: Joi.string().optional(),
    createdTimeStamp: Joi.string().optional(),
    updatedBy: Joi.string(),
    updatedTimeStamp: Joi.string(),
    states: Joi.array().items(
      {
        stateDescription: Joi.string().optional(),
        stateName: Joi.string(),
        stateUUId: Joi.string(),
      }
    ),
    status: Joi.string(),
    version: Joi.number()
  }),
});

export const sourceRegistryNameResponseSchema = Joi.array().items({
  sourceName: Joi.string().required()
}).options({ stripUnknown: true });

export const getSourceRegistryResponseSchema = Joi.object({
  id: Joi.string(),
  sourceName: Joi.string().required(),
  identifier: Joi.string().required(),
  status: Joi.string(),
  version: Joi.number(),
  createdBy: Joi.string().optional(),
  updatedBy: Joi.string().optional(),
  configJson: Joi.object({
    requestSpecJson: Joi.string().optional().allow('', null),
    responseSpecJson: Joi.string().optional(),
  }).optional(),
  createdTimestamp: Joi.string().optional(),
  eventName: Joi.string().optional(),
  eventVersion: Joi.number().optional(),
  patterns: Joi.array().items({
    eventName: Joi.string(),
    eventVersion: Joi.string(),
    id: Joi.string(),
    occurrences: Joi.string().optional(),
    patternDefinition: Joi.object({
      fieldConditionCombiners: Joi.array().items({
        combiner: Joi.string(),
        fieldConditionRefs: Joi.array().items(Joi.string()),
        n: Joi.number()
      }),
      fieldConditions: Joi.object().pattern(/.*/, Joi.object({
        contentRef: Joi.object({
          contentType: Joi.string(),
          conversionPattern: Joi.string(),
          path: Joi.array().items(Joi.string()),
          required: Joi.boolean().optional()
        }),
        operator: Joi.string(),
        value: Joi.string(),
      }))
    }),
    patternName: Joi.string(),
    timeToLive: Joi.string(),
    uniqueId: Joi.string()
  }),
  replyTimeout: Joi.string().optional(),
  replyTopicName: Joi.string().optional(),
  updatedTimestamp: Joi.string()
});

export const journeyListSchema = Joi.object({
  totalJourneysCount: Joi.number().required(),
  journeyList: Joi.array().items({
    status: Joi.string().required(),
    version: Joi.number().required(),
    createdBy: Joi.string().required(),
    createdTimeStamp: Joi.string().optional(),
    updatedBy: Joi.string().required(),
    updatedTimeStamp: Joi.string().required(),
    journeyUUID: Joi.string().required(),
    journeyName: Joi.string().required().allow(''),
    journeyType: Joi.string().optional().allow(''),
    journeyDescription: Joi.string().allow('').optional(),
    journeyStatusHistory: Joi.array().optional()
  })
});

/**
 * @method createFSMBusinessObjectApiSchema
 * @description schema definition for create Business api response.
 */
export const createFSMBusinessObjectApiSchema = Joi.array().items({
  businessObjectUUId: Joi.string().required(),
  businessObjectName: Joi.string()
    .min(1)
    .required()
}).options({ stripUnknown: true });

/**
 * @method createFSMBusinessObjectApiSchema
 * @description schema definition for create Business api response.
 */
export const fetchFSMBusinessObjectApiSchema = Joi.array().items({
  businessObjectDescription: Joi.string().optional().allow(''),
  businessObjectName: Joi.string(),
  businessObjectType: Joi.string(),
  businessObjectUUId: Joi.string(),
  businessSchemaName: Joi.string().optional(),
  businessSchemaVersion: Joi.number().optional(),
  states: Joi.array().items(
    {
      stateDescription: Joi.string(),
      stateName: Joi.string(),
      stateUUId: Joi.string(),
    }
  ),
  status: Joi.string(),
  version: Joi.number()
}).options({ stripUnknown: true });

export const fsmSchema = Joi.object({
  id: Joi.string(),
  schema: Joi.string(),
  subject: Joi.string(),
  version: Joi.number()
});

export const searchExceptionArraySchema = Joi.array().items({
  ersExceptionUUId: Joi.string(),
  ersExceptionName: Joi.string(),
  ersExceptionDescription: Joi.string(),
  ersExceptionType: Joi.string(),
  status: Joi.string(),
  version: Joi.number(),
  createdBy: Joi.string(),
  createdTimestamp: Joi.string(),
  updatedBy: Joi.string(),
  updatedTimestamp: Joi.string(),
});

const serviceExceptionResponseSchema = Joi.object({
  version: Joi.number().required(),
  createdBy: Joi.string().required(),
  updatedBy: Joi.string().required(),
  updatedTimestamp: Joi.string(),
  createdTimestamp: Joi.string(),
  ersExceptionName: Joi.string().required(),
  errorCode: Joi.string().required(),
  actions: Joi.array().items(Joi.string()).required()
});

const serviceIngressExceptionResponseSchema = Joi.object({
  ersExceptionName: Joi.string().required(),
  errorCode: Joi.string().required(),
  actions: Joi.array().items(Joi.string()).required()
});

const queryPathParamResponseSchema = Joi.object({
  index: Joi.number().optional(),
  key: Joi.string().required(),
  value: Joi.string().required(),
  isEdit: Joi.boolean().optional(),
});

const authDetailsResponseSchema = Joi.object({
  authType: Joi.string().optional(),
  authRequired: Joi.string().optional(),
  authProtocol: Joi.string().optional(),
  username: Joi.string().optional(),
  password: Joi.string().optional(),
  authMethod: Joi.string().optional(),
  authUrl: Joi.string().optional(),
  headerParam: Joi.array().items(queryPathParamResponseSchema).optional(),
  requestParam: Joi.array().items(queryPathParamResponseSchema).optional(),
  queryPathParam: Joi.array().items(queryPathParamResponseSchema).optional(),
});

const namespaceResponseSchema = Joi.object({
  prefix: Joi.string().required(),
  namespace: Joi.string().required()
});

const soapAttributeResponseSchema = Joi.object({
  headersXML: Joi.string().optional(),
  namespace: Joi.array().items(namespaceResponseSchema).optional()
});

const serviceStatusHistoryResponseSchema = Joi.array().items({
  comment: Joi.string().optional(),
  createdBy: Joi.string().required(),
  createdTimestamp: Joi.string().required(),
  status: Joi.string().required(),
  statusUuid: Joi.string().required()
});

const egressConfigSchema = Joi.object({
  responseSpecJson: Joi.string().optional(),
  mqResponseSpec: Joi.string().optional(),
  externalTopic: Joi.array().items({
    topicName: Joi.string().required(),
    connectionString: Joi.string().required(),
    partitionId: Joi.number().optional()
  })
}).options({ stripUnknown: true });

const egressEventResponseSchema = Joi.object({
  egressEventName: Joi.string().required(),
  egressEventVersion: Joi.string().required(),
  egressConfig: egressConfigSchema
});

const ingressConfigSchema = Joi.object({
  requestSpecJson: Joi.string().optional(),
  payloadToRequestHeaderSpecJson: Joi.string().optional(),
  payloadToQueryPathSpecJson: Joi.string().optional(),
  headerToRequestHeaderSpecJson: Joi.string().optional(),
  headerToRequestPayloadSpecJson: Joi.string().optional(),
  authSpecJson: Joi.string().optional(),
  exceptionMappings: Joi.array().items(serviceIngressExceptionResponseSchema),
  mqRequestSpec: Joi.string().optional(),
}).options({ stripUnknown: true });

const ingressConfigResponseSchema = Joi.object({
  ingressEventName: Joi.string().required(),
  ingressEventVersion: Joi.string().required(),
  ingressConfig: Joi.object({ ingressConfigSchema }),
  egressEvents: Joi.array().items(egressEventResponseSchema)
}).options({ stripUnknown: true });

const serviceOperationResponseSchema = Joi.object({
  serviceOperation: Joi.string().required(),
  operationUrl: Joi.string().optional(),
  operationVerb: Joi.string().optional(),
  requestAttributes: Joi.array().items(Joi.string()).optional(),
  responseAttributes: Joi.array().items(Joi.string()).optional(),
  security: Joi.string().optional(),
  queryPathParam: Joi.array().items(Joi.object({ key: Joi.string(), value: Joi.string() })).optional(),
  headerParam: Joi.array().items(Joi.object({ key: Joi.string(), value: Joi.string() })).optional(),
  ingressEvents: Joi.array().items(ingressConfigResponseSchema)
}).options({ stripUnknown: true });

export const serviceResponseSchema = Joi.object({
  uuid: Joi.string(),
  status: Joi.string(),
  version: Joi.number(),
  createdBy: Joi.string(),
  createdTimestamp: Joi.string().optional(),
  updatedBy: Joi.string(),
  updatedTimestamp: Joi.string().optional(),
  serviceName: Joi.string().required(),
  serviceCategory: Joi.string(),
  serviceDescription: Joi.string(),
  endPoint: Joi.string(),
  checkClicked: Joi.string(),
  serviceExceptions: Joi.array().items(serviceExceptionResponseSchema),
  serviceType: Joi.string().required(),
  serviceOperations: Joi.array().items(serviceOperationResponseSchema),
  authDetails: authDetailsResponseSchema,
  soapAttributes: soapAttributeResponseSchema,
  serviceStatusHistory: serviceStatusHistoryResponseSchema
}).options({ stripUnknown: true });

export const listServiceResponseSchema = Joi.object({
  status: Joi.string(),
  version: Joi.number(),
  updatedBy: Joi.string(),
  updatedTimestamp: Joi.string().optional(),
  serviceName: Joi.string().required(),
}).options({ stripUnknown: true });

export const serviceListResponseSchema = Joi.object({
  currentPageNumber: Joi.number().required(),
  numberOfPages: Joi.number().required(),
  numberOfRecordsPerPage: Joi.number().required(),
  totalRecords: Joi.number().required(),
  services: Joi.array().items(listServiceResponseSchema)
}).options({ stripUnknown: true });

export const serviceSearchResponseSchema = Joi.array().items(serviceResponseSchema);

export const eventSchema = Joi.object({
  uuid: Joi.string().guid().required(),
  eventName: Joi.string().required(),
  eventType: Joi.string().required(),
  eventDescription: Joi.string().required(),
  eventCategory: Joi.string().required(),
  schema: Joi.string().allow('').required(),
  dataEncryption: Joi.boolean().optional(),
  sensitiveFields: Joi.array().items(Joi.string()).optional(),
  eventSchemaId: Joi.string().required(),
  eventSchemaVersion: Joi.string().required(),
  status: Joi.string().required(),
  version: Joi.string().required(),
  createdBy: Joi.string().required(),
  createdTimestamp: Joi.string().isoDate().required(),
  updatedBy: Joi.string().required(),
  updatedTimestamp: Joi.string().isoDate().required(),
  eventStatusHistory: Joi.array().items(
    Joi.object({
      statusUuid: Joi.string().guid().required(),
      comment: Joi.string().allow('').optional(),
      status: Joi.string().required(),
      createdBy: Joi.string().required(),
      createdTimestamp: Joi.string().isoDate().required(),
    })
  ).optional(),
}).options({ stripUnknown: true });

export const eventListSchema = Joi.object({
  currentPageNumber: Joi.number(),
  numberOfRecordsPerPage: Joi.number(),
  totalRecords: Joi.number(),
  numberOfPages: Joi.number(),
  events: Joi.array().items({
    eventName: Joi.string().required(),
    status: Joi.string().required(),
    version: Joi.number().required(),
    updatedBy: Joi.string().required(),
    updatedTimestamp: Joi.string().isoDate().required(),
  })
}).options({ stripUnknown: true });

export const exceptionListSchema = Joi.object({
  currentPageNumber: Joi.number(),
  numberOfRecordsPerPage: Joi.number(),
  totalRecords: Joi.number(),
  numberOfPages: Joi.number(),
  ersExceptions: Joi.array().items({
    ersExceptionName: Joi.string().required(),
    status: Joi.string().required(),
    version: Joi.number().required(),
    updatedBy: Joi.string().required(),
    updatedTimestamp: Joi.string().isoDate().required(),
  })
}).options({ stripUnknown: true });
export const activeEventResponseSchema = Joi.array().items(eventSchema);

const stepNodeSchema = Joi.object({
  stepNodeId: Joi.string().allow('').optional(),
  stepName: Joi.string().allow('').optional(),
  stepDescription: Joi.string().allow('').optional(),
  eventsCount: Joi.number().integer().optional(),
  servicesCount: Joi.number().integer().optional(),
  cemCount: Joi.number().integer().optional(),
  xCoordinate: Joi.number().optional(),
  yCoordinate: Joi.number().optional(),
});

const stepEdgeSchema = Joi.array();

const eventMapNodeSchema = Joi.object({
  nodeId: Joi.string().allow('').optional(),
  serviceName: Joi.string().allow('').optional(),
  serviceDescription: Joi.string().allow('').optional(),
  serviceType: Joi.string().allow('').optional(),
  serviceVersion: Joi.number().integer().optional(),
  serviceOperationName: Joi.string().allow('').optional(),
  eventName: Joi.string().allow('').optional(),
  eventVersion: Joi.number().integer().optional(),
  isCompensateAction: Joi.boolean().optional(),
  status: Joi.string().allow('').optional(),
  xCoordinate: Joi.number().optional(),
  yCoordinate: Joi.number().optional()
});

const eventMapEdgeSchema = Joi.array();

const journeyStatusHistorySchema = Joi.object({
  journeyStatusHistoryUuid: Joi.string().allow('').optional(),
  comments: Joi.string().allow('').optional(),
  status: Joi.string().allow('').optional(),
  createdBy: Joi.string().allow('').optional(),
  createdTimestamp: Joi.string().allow('').optional()
});

const journeySchema = Joi.object({
  uuid: Joi.string().allow('').optional(),
  status: Joi.string().required(),
  version: Joi.number().integer().required(),
  createdBy: Joi.string().allow('').optional(),
  createdTimestamp: Joi.string().allow('').optional(),
  updatedBy: Joi.string().allow('').optional(),
  updatedTimestamp: Joi.string().allow('').optional(),
  journeyName: Joi.string().required(),
  journeyDescription: Joi.string().allow('').optional(),
  journeyType: Joi.string().allow('').optional(),
  journeyCategory: Joi.string().allow('').optional(),
  journeyJsonDetails: Joi.object({
    stepNodes: Joi.array().items(stepNodeSchema).required(),
    stepEdges: stepEdgeSchema
  }),
  stepDetails: Joi.object().pattern(
    Joi.string(),
    Joi.object({
      eventMapName: Joi.string().required(),
      eventMapMaxExecutionTimeInSec: Joi.number().integer().optional(),
      eventMapNodes: Joi.array().items(eventMapNodeSchema),
      eventMapEdges: eventMapEdgeSchema
    })
  ).required(),
  journeyStatusHistory: Joi.array().items(journeyStatusHistorySchema).required()
});

export const journeyListResponseSchema = Joi.object({
  totalJourneysCount: Joi.number().integer().required(),
  journeyList: Joi.array().items(journeySchema)
});
